import { render, staticRenderFns } from "./returnGoldList.vue?vue&type=template&id=69e98f68&scoped=true&"
import script from "./returnGoldList.vue?vue&type=script&lang=js&"
export * from "./returnGoldList.vue?vue&type=script&lang=js&"
import style0 from "./returnGoldList.vue?vue&type=style&index=0&id=69e98f68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e98f68",
  null
  
)

export default component.exports